import StoreManager from './data-store';
import context from '../main';
import Router from '../router';
import weixinConfig from './weixin.config';

const domain = 'https://api.shslqxh.com';

const apis = {
  userSignin: '/user/signin', // 用户登录
  userReg: '/user/reg', // 用户注册,
  smsSend: '/sms/send', //短信验证码,
  userForget: '/user/forget', // 找回密码,
  ucProfile: '/uc/profile', // 获取用户信息
  ucProfileUpdate: '/uc/profile/update', // 用户数据更新
  msgList: '/msg/list', // 通知中心
  ucMembers: '/uc/members', // 旗下会员
  ucTeams: '/uc/teams', // 我的团体
  ucTeamsFind: '/uc/teams/find', // 搜索团体
  ucTeamsJoin: '/uc/teams/join', // 加入团体,
  ucTeamsQuit: '/uc/teams/quit', // 退出团体,
  checkSession: '/user/check_session', //检查token是否过期,
  vmHp: '/vm/hp', // 首页
  userSignOut: '/user/signout', //退出登录
  ucTeamsOp: '/uc/teams/op', // 允许/拒绝加入团体
  vmAbout: '/vm/about', // 走进篮协

  userGetListPager: '/user/get_list_pager', // 获取会员分页数据
  uploadCover: '/upload/cover', // 上传图片
  uploadFiles: '/upload/files', // 上传多张图片
  uploadFile: '/upload/file', // 上传多张图片
  uploadBase64: '/upload/base64', //上传base64格式图片

  vmNews: '/vm/news', // 官方消息
  vmActivities: '/vm/activities', // 新闻中心
  vmActivitiesTag: '/vm/activities/tag', // 新闻中心筛选数据列表
  vmActivitiesTagTableId: '/vm/activities/tag/table_id', // 区篮协筛选新闻数据

  vmFlowsTag: '/vm/flows/tag', // 根据标签获取动态数据tags列表

  vmAreas: '/vm/areas', // 区篮协tab列表

  ucMemberStat: '/uc/member/stat', // 旗下成员分类统计
  ucMembersCate: '/uc/members/cate', // 根据类型获取旗下成员
  userGet: '/user/get', // 获取会员数据

  vmMatch: '/vm/match', // 篮球赛事
  vmMatchGet: '/vm/match/get', //获取篮球赛事详情

  vmActivityGet: '/vm/activity/get', // 获取动态详情
  vmTraining: '/vm/training', // 篮球培训

  vmTrainings: '/vm/trainings', // 培训tags列表数据

  vmMatchs: '/vm/matchs', //赛事tags列表数据

  vmSearch: '/vm/search', // 搜索

  userWxConfigGet: '/user/wx/config/get', // 微信分享配置

  vmActivityList: '/vm/activities/list', // 动态列表
  vmActivityEdit: '/vm/activities/edit', // 编辑动态
  vmActivityStatusUpdate: '/vm/activities/status/update', // 动态 删除/恢复
  vmAllTagBanners: '/vm/all_tag_banners',
  userQrconnect: '/user/qrconnect', // 微信扫码登录
  userLogon: '/user/logon', // 通过微信扫码登录注册
  userBind: '/user/bind', // 微信扫码登录用户绑定
  mdDivision: '/md/division', // 获取赛区详情页
  mdGet: '/md/get', // 获取赛区信息

  userExist: '/user/exist', // 检查账号名是否存在

  payGenerateQrcode: '/pay/generateqrcode', // 获取微信支付二维码信息

  payUnifiedorder: '/pay/unifiedorder', // 微信支付同意下单

  payWxPayCheck: '/pay/wx/pay.check', // 微信支付状态检查
  ucTax: '/uc/tax', // 申请发票

  vmTrainingGet: '/vm/training/get', // 根据id获取篮球培训

  ucOrders: '/uc/orders', // 获取用户订单列表
  ucOrderGet: '/uc/order/get', // 获取用户训练订单数据
  ucApplyForTraining: '/uc/apply_for_training', // 申请培训
  credentialsGet: '/credentials/get', // 查询证书信息

  judgeList: '/judge/list', // 裁判员列表, 暂时
  judgeGet: '/judge/get', // 裁判员信息
  judgeListSelf: '/judge/list/self', // 个人裁判员认证列表
  judgeStatusUpdate: '/judge/status/update', // 更新裁判员认证状态
  judgeEdit: '/judge/edit', // 裁判员认证信息编辑，
  judgeAuth: '/judge/auth', // 实人认证
  judgePassportUpdate: '/judge/passport/update', // 更新护照信息
  userInitFaceVerify: '/user/init_face_verify', // 初始化实人认证
  userDescribe_face_verify: '/user/describe_face_verify', // 实人认证
  settingsGet: '/settings/get', // 获取配置
  judgeModified: '/judge/modified', //裁判员认证信息是否修改
  userUpdateStatus: '/user/update/status', //更新会员申请状态
  userModified: '/user/modified', //会有员信息是否修改
  userAuditStatus: '/user/audit_status',

  coachGet: '/coach/get', // 获取教练员（不需要token）
  coachGetByUserId: '/coach/get_by_user_id', // 获取教练员（需要token）

  coachModified: '/coach/modified', // 教练员认证信息是否修改
  coachStatusUpdate: '/coach/status/update', // 更新教练员认证状态

  coachList: '/coach/list', // 认证教练员列表

  coachEdit: '/coach/edit', // 教练员认证信息编辑
  coachEditCertificates: '/coach/edit_certificates', // 教练员证书编辑
  coachEditCultivates: '/coach/edit_cultivates', // 教练员参培经历编辑
  coachEditResumes: '/coach/edit_resumes', // 教练员执教履历编辑

  coachAdd: '/coach/add', // 教练员认证信息新增
  coachDel: '/coach/del', // 教练员删除
  coachGetListByUserId: '/coach/get_list_by_user_id', // 获取教练员列表
};

// 不需要token 的接口备注
const apiWhiteList = [
  apis.userSignin,
  apis.smsSend,
  apis.userReg,
  apis.userForget,
  apis.vmHp,
  apis.vmAbout,
  apis.vmNews,
  apis.vmActivities,
  apis.userGetListPager,
  apis.userGet,
  apis.vmActivitiesTag,
  apis.vmActivitiesTagTableId,
  apis.vmAreas,
  apis.vmActivityGet,
  apis.vmTraining,
  apis.vmMatch,
  apis.vmMatchGet,
  apis.vmSearch,
  apis.userWxConfigGet,
  apis.vmFlowsTag,
  apis.vmAllTagBanners,
  apis.userQrconnect,
  apis.userLogon,
  apis.userBind,
  apis.mdDivision,
  apis.mdGet,
  apis.userExist,
  apis.vmTrainingGet,
  apis.credentialsGet,
  apis.judgeList,
  apis.judgeGet,
  apis.settingsGet,
  apis.coachList,
  apis.coachGet,
];

const ajax = {
  post(url, params, success, failure) {
    let path = domain + url;
    let paramsStr = '';
    if (params != undefined && params != null && Object.values(params).length > 0) {
      paramsStr = JSON.stringify(params);
    }

    let headers = {}
    let needToken = false;
    if (apiWhiteList.indexOf(url) == - 1) {
      let token = StoreManager.getToken();
      if (token == null || token == '') {
        let href = window.location.href;
        StoreManager.setRedirectUrl(href);
        failure({
          code: -1
        });
        Router.push({name: 'loginPage'});
        return;
      }
      headers.token = token;
      needToken = true;
    }

    let _this = this;
    // console.log(paramsStr + '--- ' + headers.token);
    // console.log('--- test');
    $.ajax({
      type: "POST",
      url: path,
      headers: headers,
      contentType: "application/json;charset=utf-8",
      data: paramsStr,
      dataType: "json",
      success: function (data) {
        if (needToken) {
          let code = data.code;
          if (code == -1) {
            _this.dealWithTokenInvalid();
            failure({
              code: -1
            });
            return;
          }
        }
        success(data);

      },
      error: failure
    });
  },
  get(url, params, success, failure) {
    let path = domain + url;
    var paramsStr = '';
    if (params != undefined && params != null && Object.values(params).length > 0) {
      paramsStr = JSON.stringify(params);
    }
    let headers = {}
    let needToken = false;
    if (apiWhiteList.indexOf(url) == - 1) {
      let token = StoreManager.getToken();
      // console.log(token);
      if (token == null || token == '') {
        let href = window.location.href;
        StoreManager.setRedirectUrl(href);
        failure({
          code: -1
        });
        Router.push({name: 'loginPage'});
        return;
      }
      headers.token = token;
      needToken = true;
    }

    let _this = this;
    $.ajax({
      type: "GET",
      headers: headers,
      url: path,
      contentType: "application/json; charset=utf-8",
      data: params,
      dataType: "json",
      success: function (data) {
        if (needToken) {
          let code = data.code;
          if (code == -1) {
            _this.dealWithTokenInvalid();
            failure({
              code: -1
            });
            return;
          }
        }
        success(data);

      },
      error: failure
    });
  },


  getSpec(url, params, success, failure) {
    let path = domain + url;
    var paramsStr = '';
    if (params != undefined && params != null && Object.values(params).length > 0) {
      paramsStr = JSON.stringify(params);
    }
    let headers = {}
    if (apiWhiteList.indexOf(url) == - 1) {
      let token = StoreManager.getToken();
      // console.log(token);
      if (token == null || token == '') {
        token = '';
      }
      headers.token = token;
    }

    let _this = this;
    // console.log('---1');
    // console.log(headers);
    $.ajax({
      type: "GET",
      headers: headers,
      url: path,
      contentType: "application/json; charset=utf-8",
      data: params,
      dataType: "json",
      success: function (data) {
        success(data);
      },
      error: failure
    });
  },

  postImage(imageData, complete) {
    if (imageData == null) {
      // console.log('imageData null');
      return;
    }

    // console.log(imageData);

    let params = {
      base64Data: imageData
    }

    let url = apis.uploadBase64;

    let headers = {}
    let needToken = false;
    if (apiWhiteList.indexOf(url) == - 1) {
      let token = StoreManager.getToken();
      if (token == null || token == '') {
        let href = window.location.href;
        StoreManager.setRedirectUrl(href);
        Router.push({name: 'loginPage'});
        return;
      }
      headers.token = token;
      needToken = true;
    }

    // console.log(headers);

    url = domain + url;
    // console.log(url);
    $.ajax({
      url: url,   //自己的路径
      headers,
      type: "POST",
      dataType: "json",
      cache: false,
      data: JSON.stringify(params) ,
      contentType: "application/json;charset=utf-8",
      processData: false,// 不处理数据

      async:false,
      complete: function(result) {
        // // console.log('complete');
        // // console.log(result);
        let code = result.status == 200 ? 0 : 1;
        let imageUrl = code == 0 ? result.responseText : '';
        complete(code, imageUrl);
      },
    });
  },


  dealWithTokenInvalid() {
    StoreManager.clearUser();
    StoreManager.setBanners(null);
    context.$store.commit('setBanners', null);
    context.$store.commit('setUser', null);
    setTimeout(function () {
      let href = window.location.href;
      StoreManager.setRedirectUrl(href);
      Router.push({name: 'loginPage'});
    }, 1000);
  },

  userSignin(params, success, failure) {
    this.post(apis.userSignin, params, success, failure);
  },
  userReg(params, success, failure) {
    this.post(apis.userReg, params, success, failure);
  },

  smsSend(params, success, failure) {
    this.post(apis.smsSend, params, success, failure);
  },

  userForget(params, success, failure) {
    this.post(apis.userForget, params, success, failure);
  },

  ucProfile(success, failure) {
    let _this = this;
    this.get(apis.ucProfile, null ,function (data) {
      if (data.code == 0) {
        //...保存数据
      }
      success(data);

    }, failure);
  },

  ucProfileUpdate (params, success, failure) {
    this.post(apis.ucProfileUpdate, params, success, failure);
  },

  msgList(params, success, failure) {
    this.get(apis.msgList, params, success, failure);
  },
  ucMembers(params, success, failure) {
    this.get(apis.ucMembers, params, success, failure);
  },
  ucTeams(success, failure) {
    this.get(apis.ucTeams, null, success, failure);
  },

  ucTeamsFind(params,success, failure) {
    this.get(apis.ucTeamsFind, params, success, failure);
  },

  ucTeamsJoin(params, success, failure) {
    this.post(apis.ucTeamsJoin, params, success, failure);
  },

  ucTeamsQuit(params, success, failure) {
    this.post(apis.ucTeamsQuit, params, success, failure);
  },

  vmHp(success, failure) {
    this.get(apis.vmHp, null, success, failure);
  },

  checkSession(params, success, failure) {
    this.getSpec(apis.checkSession, params, success, failure);
  },

  userSignOut(success, failure) {
    let _this = this;

    let clearState = function () {
      StoreManager.clearUser();
      StoreManager.setBanners(null);
      context.$store.commit('setBanners', null);
      context.$store.commit('setUser', null);
    };

    this.get(apis.userSignOut, null, function (data) {
      clearState();
      success(data);
    }, function (data) {
      clearState();
      failure(data);
    });
  },
  ucTeamsOp(params, success, failure) {
    this.post(apis.ucTeamsOp, params, success, failure);
  },
  vmAbout(success, failure) {
    this.get(apis.vmAbout, null, success, failure);
  },

  userGetListPager(params, success, failure) {
    this.get(apis.userGetListPager, params, success, failure);
  },
  vmNews(params, success, failure) {
    this.get(apis.vmNews, params, success, failure);
  },
  vmActivities(params, success, failure) {
    let tag = params.tag;
    if (tag == '全部') {
      delete params['tag'];
      this.get(apis.vmActivities, params, success, failure);
    } else {
      this.get(apis.vmActivitiesTag, params, success, failure);
    }
  },

  ucMemberStat(success, failure) {
    this.get(apis.ucMemberStat, null, success, failure);
  },
  ucMembersCate(params, success, failure) {
    this.get(apis.ucMembersCate, params, success, failure);
  },
  userGet(params, success, failure) {
    this.get(apis.userGet, params, success, failure);
  },

  otherAssociationData(params, success, failure) {
    let tag = params.tag;
    if (tag == '各区篮协') {
      params.tag = '区篮协';
    }
    this.get(apis.vmFlowsTag, params, success, failure);
  },

  matchDeatilList(params, success, failure) {
    this.get(apis.vmFlowsTag, params, success, failure);
  },

  vmAreas(success, failure) {
    this.get(apis.vmAreas, null, success, failure);
  },
  vmMatch(params, success, failure) {
    this.get(apis.vmMatch, params, success, failure);
  },
  vmActivityGet(activityId, success, failure) {
    if (activityId != undefined && activityId != null) {
      let params = {
        activityId,
      }
      // console.log(params);
      this.get(apis.vmActivityGet, params, success, failure);
    }
  },
  vmTraining(success, failure) {
    this.get(apis.vmTraining, null, success, failure);
  },
  vmMatchGet(matchId, success, failure) {
    if (matchId == null) {
      return;
    }
    // console.log(matchId);
    this.get(apis.vmMatchGet, {matchId,}, success, failure);
  },
  vmSearch(params, success, failure) {
    this.get(apis.vmSearch, params, success, failure);
  },
  userWxConfigGet(url, success, failure) {
    if (url == null || url == undefined) {
      return;
    }
    let params = {
      url
    };
    this.get(apis.userWxConfigGet, params, success, failure);
  },
  vmActivityList(params, success, failure) {
    this.get(apis.vmActivityList, params, success, failure);
  },

  vmActivityEdit(params, success, failure) {
    this.post(apis.vmActivityEdit, params, success, failure);
  },
  vmMatchs(success, failure) {
      this.get(apis.vmMatchs, null,success, failure);
  },

  vmTrainings(success, failure) {
    this.get(apis.vmTrainings, null, success, failure);
  },
  vmActivityStatusUpdate(params, success, failure) {
    this.post(apis.vmActivityStatusUpdate, params, success, failure);
  },
  vmAllTagBanners(success, failure) {
    this.get(apis.vmAllTagBanners, null,success, failure);
  },
  userBind(params, success, failure) {
    this.post(apis.userBind, params, success, failure);
  },

  userQrconnect(params, success, failure) {
    this.get(apis.userQrconnect, params, success, failure);
  },

  userLogon(params, success, failure) {
    this.post(apis.userLogon, params, success, failure);
  },
  mdDivision(params, success, failure) {
    this.get(apis.mdDivision, params, success, failure);
  },
  mdGet(matchId, success, failure) {
    let params = {
      id: matchId
    };
    console.log(params);
    this.get(apis.mdGet, { id: matchId}, success, failure);
  },
  userExist(nickName, success, failure) {
    if (nickName == undefined || nickName == null || nickName.length == 0) {
      return;
    }
    let params = {
      nickname: nickName
    };
    this.get(apis.userExist, params, success, failure);
  },
  getPayGenerateQrcode(params, success, failure) {
    this.get(apis.payGenerateQrcode, params, success, failure);
  },

  getPayUnifiedorderData(params, success, failure) {
    this.get(apis.payUnifiedorder, params, success, failure);
  },

  getPayWxPayCheckData(params, success, failure) {
    this.get(apis.payWxPayCheck, params, success, failure);
  },
  postUcTaxRequest(params, success, failure) {
    this.post(apis.ucTax, params, success, failure);
  },
  getVmTrainingGetData(params, success, failure) {
    this.get(apis.vmTrainingGet, params, success, failure);
  },
  getUcOrdersData(success, failure) {
    this.get(apis.ucOrders, null, success, failure);
  },

  getTrainOrderData(params, success, failure) {
    this.get(apis.ucOrderGet, params, success, failure);
  },

  sendTrainingApplicaitonRequest(params, success, failure) {
    this.post(apis.ucApplyForTraining, params, success, failure);
  },

  getCredentialsData(params, success, failure) {
    this.get(apis.credentialsGet, params, success, failure);
  },

  /*
  * 获取裁判员列表数据
  * */
  getJudgeListData(params, success, failure) {
    this.get(apis.judgeList, params, success, failure);
  },

  getJudgeDetailData(id, success, failure) {
    let params = {
      id: id,
    };
    this.get(apis.judgeGet, params, success, failure);
  },
  getJudgeListSelfData(success, failure) {
    this.get(apis.judgeListSelf, null, success, failure);
  },
  updateJudgeStatusData(params, success, failure) {
    this.post(apis.judgeStatusUpdate, params, success, failure);
  },
  postJudgeAuthRequest(params, success, failure) {
    this.post(apis.judgeAuth, params, success, failure);
  },
  postJudgeEditData(params, success, failure) {
    this.post(apis.judgeEdit, params, success, failure);
  },
  postUserFaceVerifyInitData(params, success, failure) {
    this.post(apis.userInitFaceVerify, params, success, failure);
  },

  getUserDescribeFaceVerifyData(params, success, failure) {
    this.get(apis.userDescribe_face_verify, params, success, failure);
  },

  postupdateJudgePassportData(params, success, failure) {
    this.post(apis.judgePassportUpdate, params, success, failure);
  },

  // 获取裁判员身份认证申请开放时间段
  getJudgeApplyDateData(success, failure) {
    let params = {
      key: 'judge_apply_section'
    };
    this.get(apis.settingsGet, params, success, failure);
  },

  // 获取会员认证申请开放时间段
  getMemberApplyDateData(success, failure) {
    let params = {
      key: 'member_apply_section'
    };
    this.get(apis.settingsGet, params, success, failure);
  },

  postJudgeModifiedData(params, success, failure) {
    this.post(apis.judgeModified, params, success, failure);
  },
  postUserUpdateStatusRequest(params, success, failure) {
    this.get(apis.userUpdateStatus, params, success, failure);
  },

  postUserModifiedChangeRequest(params, success, failure) {
    this.post(apis.userModified, params, success, failure);
  },
  postUpdateUserAuditStatusRequest(params, success, failure) {
    this.post(apis.userAuditStatus, params, success, failure);
  },

  getCoachData(params, success, failure) {
	this.get(apis.coachGet, params, success, failure);
  },

  getCoachDataByUserId(params, success, failure) {
	  this.get(apis.coachGetByUserId, params, success, failure);
  },

  getCoachListData(params, success, failure) {
    this.get(apis.coachList, params, success, failure);
  },

  postCoachEditRequest(params, success, failure) {
	this.post(apis.coachEdit, params, success, failure);
  },

  postCoachEditCertificatesRequest(params, success, failure) {
	this.post(apis.coachEditCertificates, params, success, failure);
  },

  postCoachEditCultivatesRequest(params, success, failure) {
    this.post(apis.coachEditCultivates, params, success, failure);
  },

  postCoachEditResumesRequest(params, success, failure) {
    this.post(apis.coachEditResumes, params, success, failure);
  },

  postCoachAddRequest(params, success , failure) {
    this.post(apis.coachAdd, params, success, failure);
  },
  postCoachStatusUpdateRequest(params, success, failure) {
    this.post(apis.coachStatusUpdate, params, success, failure);
  },

  getUserCoachListData(params, success, failure) {
    this.get(apis.coachGetListByUserId, params, success, failure);
  },

  postCoachDeleteRequest(params, success, failure) {
    this.get(apis.coachDel, params, success, failure);
  }
};


export default {
  ajax: ajax,
  defaultShareObj: {
    title: '上海市篮球协会',
    desc: '上海市篮球协会官网',
    link: 'https://shslqxh.com',
    imgUrl: 'https://img.shslqxh.com/shl_share_default.png',
  }
}



// WEBPACK FOOTER //
// ./src/js/api-defines.js